import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  CruisePurchaseModel,
  CruisePurchaseMutationInput,
  CruisePurchaseDeleteInput,
  CruisePurchaseUpdateInput,
} from './model';

export function useCreateCruisePurchase(
  options?: UseMutationOptions<
    ApiResult<CruisePurchaseModel>,
    ApiError,
    CruisePurchaseMutationInput
  >,
): UseMutationResult<
  ApiResult<CruisePurchaseModel>,
  ApiError,
  CruisePurchaseMutationInput
> {
  return useMutation<
    ApiResult<CruisePurchaseModel>,
    ApiError,
    CruisePurchaseMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'cruise-purchases',
      method: 'POST',
      classType: CruisePurchaseModel,
      body,
    });
  }, options);
}

export function useUpdateCruisePurchase(
  options?: UseMutationOptions<
    ApiResult<CruisePurchaseModel>,
    ApiError,
    CruisePurchaseUpdateInput
  >,
): UseMutationResult<
  ApiResult<CruisePurchaseModel>,
  ApiError,
  CruisePurchaseUpdateInput
> {
  return useMutation<
    ApiResult<CruisePurchaseModel>,
    ApiError,
    CruisePurchaseUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `cruise-purchases/${body.cruisePurchaseId}`,
      method: 'PUT',
      classType: CruisePurchaseModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteCruisePurchase(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    CruisePurchaseDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, CruisePurchaseDeleteInput> {
  return useMutation<{ message: string }, ApiError, CruisePurchaseDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `cruise-purchases/${body.cruisePurchaseId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}

export function useVoidCruisePurchase(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    CruisePurchaseDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, CruisePurchaseDeleteInput> {
  return useMutation<{ message: string }, ApiError, CruisePurchaseDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `cruise-purchases/${body.cruisePurchaseId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
